export const PLACEHOLDER =
	'Search Filter : select options from suggested values, for IN/NOT IN operators - press "Enter" after selecting options';
